import axios from '@/services'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import i18n from '@/i18n/i18n'
import { notify } from 'notiwind'
import client_config from '@/assets/json/client_config.json'
import router from '@/router'
import apiHelperService from '@/services'
import { default as client_lookups } from '@/assets/json/clientLookups.json'
import Loading from '@/components/Ui/Loading/index.js'
import { useAuthStore } from '@/stores/auth'

let readDataCallBack = null
let readDataErrorCallBack = null
let ToolkitOB = null
let IsSam = {
  sam_secure_messaging: true
}
let readerList = null
let readerName = null
let readerClass = null
let options = {
  //"jnlp_address": "../../scripts/IDCardToolkitService.jnlp",
  debugEnabled: false,
  agent_tls_enabled: false,
  agent_host_name: 'toolkitagent.emiratesid.ae',
  CONFIRM_TEXT_WINDOWS: i18n.global.t('downloadSDKAgentMessage'),
  toolkitConfig: 'read_publicdata_offline = true \n'
}
let cardWebsocket = null
let websocket = null

const clearApplicantInformation = () => {
  const formStore = useFormStore()

  formStore.form.setValues({
    englishApplicantName: '',
    arabicApplicantName: '',
    applicantIdentityNumber: '',
    sponsorNumber: '',
    sponsorIdentityNumber: ''
  })
  // update data only get from draft check useTypingCenterDraftOverrideStore line 43
  formStore.draft.request = {
    ...formStore.draft.request,
    englishApplicantName: '',
    arabicApplicantName: '',
    applicantIdentityNumber: '',
    sponsorNumber: '',
    sponsorIdentityNumber: ''
  }
}

const setSponsorType = () => {
  const formStore = useFormStore()
  const {
    ServiceTransactions: {
      residenceForResidentFamilyWorkingInPublicSector,
      ResidenceForResidentFamilyWorkingInPrivertSectorOrFreezone,
      visaForResidentWorkingForUaeCitizenOrGccCitizenSponsores
    }
  } = client_lookups

  const { serviceId } = router.currentRoute.value.params

  const isIncludedService = [
    residenceForResidentFamilyWorkingInPublicSector,
    ResidenceForResidentFamilyWorkingInPrivertSectorOrFreezone,
    visaForResidentWorkingForUaeCitizenOrGccCitizenSponsores
  ].includes(serviceId)

  Object.assign(formStore.extraMap, {
    isResidentFamilyWorkingInPublicSector: isIncludedService
  })

  formStore.form.setValues({
    sponsorTypeId: 4,
    sponsorTypeCode: 3
  })

  formStore.draft.request = {
    ...formStore.draft.request,
    sponsorTypeId: 4,
    sponsorTypeCode: 3
  }
}

const getPersonVisaResiInfo = async (identityNumber) => {
  const formStore = useFormStore()
  const options = {
    identityNumber
  }

  const res = await apiHelperService.get(`/api/user/getPersonInfoFromEdia`, { params: options })
  if (res) {
    const { personUnifiedNumber, gender, nationalityId } = res
    formStore.form.setValues({
      ...(personUnifiedNumber && { sponsorNumber: personUnifiedNumber }),
      ...(gender && { sponsorGenderId: gender }),
      ...(nationalityId && { sponsorNationalityId: nationalityId })
    })
    setSponsorType()
  } else {
    formStore.form.setValues({
      sponsorNumber: '',
      sponsorIdentityNumber: '',
      sponsorNationalityId: nationalityId
    })

    formStore.draft.request = {
      ...formStore.draft.request,
      sponsorNumber: '',
      sponsorIdentityNumber: '',
      sponsorNationalityId: nationalityId
    }

    notify(
      {
        group: 'error',
        title: 'error',
        text: i18n.global.t('warningMessageNoSponsorinfo')
      },
      6000
    )
  }
}

const reuseRequest = (response) => {
  const formStore = useFormStore()
  const {
    applicantEmail,
    applicantMobile,
    preferedLanguageId,
    localEmirateId,
    localCityId,
    localAreaId,
    buildingName,
    flatNumber,
    localPobox,
    localMobile,
    localHomePhone,
    emailAddress,
    abroadCountryId,
    abroadPhone,
    deliveryMethodId,
    deliveryCompanyId,
    tawzeaDeliveryEmirateId,
    tawzeaDeliveryCityId,
    tawzeaDeliveryAreaId,
    landMarkId,
    deliveryAddressDetails,
    deliveryMobileNumber,
    secondMobileNumber,
    sponsorDepartmentId,
    sponsorNumber,
    sponsorIdentityNumber,
    sponsorTypeId,
    sponsorEnglishName,
    sponsorArabicName,
    sponsorNationalityId,
    sponsorGenderId,
    sponsorPassportNo,
    localAddress: { name: localAddressName },
    abroadAddress: { name: abroadAddressName }
  } = response
  const payload = {
    applicantEmail,
    applicantMobile,
    preferedLanguageId,
    localEmirateId,
    localCityId,
    localAreaId,
    buildingName,
    flatNumber,
    localPobox,
    localMobile,
    localHomePhone,
    emailAddress,
    abroadCountryId,
    abroadPhone,
    deliveryMethodId,
    deliveryCompanyId,
    tawzeaDeliveryEmirateId,
    tawzeaDeliveryCityId,
    tawzeaDeliveryAreaId,
    landMarkId,
    deliveryAddressDetails,
    deliveryMobileNumber,
    secondMobileNumber,
    sponsorDepartmentId,
    sponsorNumber,
    sponsorIdentityNumber,
    sponsorTypeId,
    sponsorEnglishName,
    sponsorArabicName,
    sponsorNationalityId,
    sponsorGenderId,
    sponsorPassportNo
  }
  formStore.form.setValues(payload)
  formStore.form.setValue('localAddress.name', localAddressName)
  formStore.form.setValue('abroadAddress.name', abroadAddressName)

  formStore.draft.request = {
    ...formStore.draft.request,
    ...payload,
    localAddress: {
      name: localAddressName
    },
    abroadAddress: {
      name: abroadAddressName
    }
  }

  notify(
    {
      group: 'success',
      title: 'success',
      text: i18n.global.t('reusedApplicantInformationSuccessfully')
    },
    6000
  )
}

const handleCardReaderData = async (result) => {
  const formStore = useFormStore()
  const reusedFromRequest = router.currentRoute.value.query.reusedFromRequest
  const idNumber = result.IdNumber?.replace(/-/g, '')
  formStore.form.setValues({
    englishApplicantName: result.EnglishFullName,
    arabicApplicantName: result.ArabicFullName,
    applicantIdentityNumber: idNumber,
    sponsorIdentityNumber: idNumber
  })

  formStore.draft.request = {
    ...formStore.draft.request,
    englishApplicantName: result.EnglishFullName,
    arabicApplicantName: result.ArabicFullName,
    applicantIdentityNumber: idNumber,
    sponsorIdentityNumber: idNumber
  }

  const applicantIdentityNumber = formStore.form.values?.applicantIdentityNumber

  idNumber && getPersonVisaResiInfo(idNumber)

  if (reusedFromRequest && client_config.enableReuseRequestForTheSameSponsor) {
    const res = await apiHelperService.get(
      `/api/typingCenter/visa/draft/reusedFromRequest/${reusedFromRequest}/${applicantIdentityNumber}`
    )
    reuseRequest(res.request)
  }
}

const readDataFromCard = () => {
  const authStore = useAuthStore()
  if (!authStore.isUserTypingCenter) return

  return new Promise((resolve, reject) => {
    initializeCardReader(
      (result) => {
        if (result) {
          handleCardReaderData(result)
          resolve(result)
        } else {
          clearApplicantInformation()
        }
      },
      (error) => {
        console.log('readDataFromCard error', error)
        notify(
          {
            group: 'error',
            title: 'error',
            text: error.message || i18n.global.t('error')
          },
          6000
        )
        reject('error', error)
      }
    )
  })
}
const initializeCardReader = (callback, errorCallback) => {
  Loading.loading.show()
  readDataCallBack = callback
  readDataErrorCallBack = errorCallback
  let browser = getBrowser()
  if (browser != 'unknown') {
    // For IE
    // provide the call backs
    ToolkitOB = new Toolkit(
      onOpenCB, // reference to onOpenCB call back function
      onCloseCB, // reference to onCloseCB call back function
      onErrorCB, // reference to onErrorCB call back function
      options // toolkit script options object
    )
  }
}

const getBrowser = () => {
  let userAgent = window.navigator.userAgent
  let browsers = {
    chrome: /chrome/i,
    safari: /safari/i,
    firefox: /firefox/i,
    ie: /internet explorer/i
  }
  for (let key in browsers) {
    if (browsers[key].test(userAgent)) {
      return key
    }
  }
  return 'unknown'
}
const onOpenCB = (response, error) => {
  if (error === null) {
    /**
     * call the list reader function and pass listReaderCB to be executed
     * after the response is received from server
     */
    if (IsSam.sam_secure_messaging) {
      ToolkitOB.getReaderWithEmiratesId(listReaderCB)
    } else {
      ToolkitOB.listReaders(listReaderCB)
    }
  } else {
    ToolkitOB = null
  }
}
const onCloseCB = (response, error) => {
  ToolkitOB = null
  readerClass = null
  if (null !== response && undefined == response) {
    Loading.loading.hide()
  }
}
const onErrorCB = (err) => {
  readerClass = null
  ToolkitOB = null
  if (null !== err) {
    Loading.loading.hide()
  }
}

const listReaderCB = (response, error) => {
  if (error !== null) {
    Loading.loading.hide()
    // alert(error.message || error.description);
    readDataErrorCallBack(error)
    ToolkitOB = null
  } else {
    readerName = null
    readerList = response
    if (IsSam.sam_secure_messaging) {
      readerClass = readerList
    } else {
      if (readerList && 0 < readerList.length) {
        readerClass = readerList[0]
      } else {
        Loading.loading.hide()
        return 'No readers found'
      }
    }
    /**
     * call the connect reader function and pass connectReaderCB to be executed
     * after the response is received from server
     */
    let ret = readerClass.connect(connectReaderCB)
  }
}
const connectReaderCB = (response, error) => {
  if (null != response) {
    //      console.log('Connected to the reader..');
    DisplayPublicData(false)
  }
  if (null != error) {
    Loading.loading.hide()
    return error.code + ' : ' + error.message
  }
}
const DisplayPublicData = (nfc) => {
  if (null === readerClass || undefined === readerClass) {
    //  alert('ERROR : Reader is not initiaized.');
    return
  }
  /*  disable all buttons till request is processed */
  /*  generate the random string */
  let randomStr = generateRandomString(40)
  /* convert randomString to base64 */
  let requestId = btoa(randomStr)
  /**
   * call the read public data function and pass readPublicDataCB to be executed
   * after the response is received from server
   */
  let address = true
  if (self.IsNfc) {
    address = false
  }
  readerClass.readPublicData(requestId, true, true, true, true, address, readPublicDataCB)
}
const readPublicDataCB = (response, error) => {
  Loading.loading.hide()
  if (error === null) {
    //   alert(response);
    let readerData = {
      EnglishFullName: response.nonModifiablePublicData.fullNameEnglish
        .replace(/[\*\\]/, '')
        .replace(/,+/g, ' '),
      ArabicFullName: response.nonModifiablePublicData.fullNameArabic
        .replace(/[\*\\]/, '')
        .replace(/,+/g, ' '),
      IdNumber: response.iDNumber.replace(/[\*\\]/, ''),
      NationalityCode: response.nonModifiablePublicData.nationalityCode,
      investorUnifiedNumber: response.modifiablePublicData.sponsorUnifiedNumber,
      CardexpiryDate: response.nonModifiablePublicData.expiryDate,
      Gender: response.nonModifiablePublicData.gender,
      BirthDate: response.nonModifiablePublicData.dateOfBirth
    }
    readDataCallBack(readerData)
  } else {
    readDataErrorCallBack(error)
    // alert(error.message);
  }
  /* enable all buttons as request is completed */
}
const generateRandomString = (length) => {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

//Initialize 3m Reader WebSocket
const initializeCardOnTheBegin = (scope, callback) => {
  var browser = getBrowser()
  if (browser != 'unknown') {
    // For IE
    websocket = new WebSocket(client_config.passport3MWebSocketUrl)
    // websocket = new WebSocket('ws://192.168.81.174:9004')
    let result = null
    websocket.onopen = function (event) {
      onOpen(event)
    }
    websocket.onmessage = function (event) {
      result = onMessage(event)
      if (result && result.Message.DocType) {
        callback(mapData(scope, result.Message))
      }
    }
    websocket.onerror = function (event) {
      onError(event)
    }
    websocket.onclose = function (event) {}
  }
}
const onOpen = (event) => {
  let config = {
    Message: {
      Aztec: false,
      DataMatrix: false,
      EnableAAMVA: false,
      EnableIR: true,
      EnablePhoto: true,
      EnableRF: true,
      EnableRFMRZ: true,
      EnableRFPhoto: true,
      EnableUV: true,
      EnableVIS: true,
      OneD: false,
      PDF417: true,
      QRcode: false
    },
    Type: 'START'
  }
  websocket.send(JSON.stringify(config))
}
const onMessage = (event) => {
  let data = event.data
  let result = null
  //check if the webSocket get data from scanner
  if (data != 'ping') {
    result = JSON.parse(event.data)
  }
  return result
}
const onError = (event) => {
  let errorMessage = event.data
}
const mapData = (scope, result) => {
  result.fullName = result.Forenames + ' ' + result.Surname
  result.dateOfBirth = result.DateofBirth
  result.expiryDate = result.DateofExpiry
  result.documentNumber = result.DocumentNumber
  result.genderId = result.Sex.toLowerCase() == 'male' ? 1 : 0
  result.issuer = getCountryText(scope.countries, result.Issuer.toLowerCase())
  result.nationalityId = getCountryId(scope.countries, result.Nationality.toLowerCase())
  return result
}
const getCountryText = (countries, isoCode) => {
  if (isoCode) {
    if (countries) {
      var country = countries.filter(function (country) {
        if (country.isoThreeCharactersCode.toLowerCase() == isoCode) return true
        return false
      })[0]

      if (country) return country.text
    }
  }
}

const getCountryId = (countries, isoCode) => {
  if (isoCode) {
    if (countries) {
      var country = countries.filter(function (country) {
        if (country.isoThreeCharactersCode.toLowerCase() == isoCode) return true
        return false
      })[0]

      if (country) return country.id
    }
  }
}

const retriveVisaInformation = async () => {
  const formStore = useFormStore()
  if (formStore.extraMap.recaptchaResponseForRetriveVisa != null) {
    const {
      nationalityId = '',
      passportNum = '',
      dateOfBirth = '',
      departureDate = '',
      passportTypeId = ''
    } = formStore.form.values || {}
    params = {
      currentNationalityId: nationalityId,
      passportNumber: passportNum,
      dateOfBirth: dateOfBirth,
      departureDate: departureDate,
      passportTypeId: passportTypeId
    }
    let fileNumberData = await axios.request({
      url: '/api/guest/visa/retriveVisaInfo',
      method: 'POST',
      data: params
    })
    formStore.extraMap.visaInfo = fileNumberData
    if (fileNumberData) {
      formStore.extraMap.isOpenRetriveVisaInfoSection =
        !formStore.extraMap.isOpenRetriveVisaInfoSection
      // formStore.extraMap.showAllSectionOnResponse = true
      const {
        arabicApplicantName = '',
        englishApplicantName = '',
        applicantEmail = '',
        preferedLanguageId = '',
        applicantMobile = '',
        personUnifiedNumber = '',
        englishName = '',
        arabicName = '',
        currentNationalityId = '',
        previousNationalityId = '',
        genderId = '',
        dateOfBirth = '',
        countryOfBirthId = '',
        englishPlaceOfBirth = '',
        arabicPlaceOfBirth = '',
        passportNumber = '',
        passportEnglishIssuePlace = '',
        passportArabicIssuePlace = '',
        passportCountryId = '',
        passportIssueDate = '',
        passportExpiryDate = '',
        passportTypeId = '',
        religionId = '',
        faithId = '',
        maritalStatusId = '',
        educationLevelId = '',
        motherEnglishName = '',
        motherArabicName = '',
        vistReason = '',
        emailAddress = '',
        localEmirateId = '',
        localCityId = '',
        localAreaId = '',
        localAddress = '',
        buildingName = '',
        localPobox = '',
        localHomePhone = '',
        localWorkPhone = '',
        localMobile = '',
        abroadCountryId = '',
        abroadAddress = '',
        abroadPhone = '',
        professionId = ''
      } = fileNumberData
      formStore.extraMap.hidereCAPTCHA = true
      formStore.draft.request = {
        ...fileNumberData
      }
      formStore.form.setValues({
        professionId,
        //mapping visa information
        //applicant information
        arabicApplicantName,
        englishApplicantName,
        applicantEmail,
        preferedLanguageId,
        applicantMobile,
        //beneficiary identification Information
        personUnifiedNumber,
        //personal information
        englishName,
        arabicName,
        currentNationalityId,
        previousNationalityId,
        genderId,
        dateOfBirth,
        countryOfBirthId,
        englishPlaceOfBirth,
        arabicPlaceOfBirth,
        passportNumber,
        passportEnglishIssuePlace,
        passportArabicIssuePlace,
        passportCountryId,
        passportIssueDate,
        passportExpiryDate,
        passportTypeId,
        religionId,
        faithId,

        maritalStatusId,
        educationLevelId,
        motherEnglishName,
        motherArabicName,
        vistReason,
        emailAddress,

        //Address inside UAE
        localEmirateId,
        localCityId,
        localAreaId,
        localAddress,
        buildingName,
        localPobox,
        localHomePhone,
        localWorkPhone,
        localMobile,

        //Address outside UAE
        abroadCountryId,
        abroadAddress,
        abroadPhone
      })
    }
  } else {
    notify(
      {
        group: 'error',
        title: 'error',
        text: i18n.global.t('captchaNotProcessed')
      },
      6000
    )
  }
}
const selectIdentificater = async () => {
  const formStore = useFormStore()
  formStore.draft.request = {
    ...formStore.draft.request,
    personUnifiedNumber: '',
    departmentCode: '',
    serviceYear: '',
    serviceCode: '',
    sequenceNumber: ''
  }
  formStore.form.setValues({
    personUnifiedNumber: '',
    departmentCode: '',
    serviceYear: '',
    serviceCode: '',
    sequenceNumber: ''
  })
}
const checkNominationRequestNumber = async () => {
  const formStore = useFormStore()
  const { nomantionRequestNumber, userEmail } = router.currentRoute.value.query || {}
  const {
    request: {
      referenceRequestNumber,
      nominationEmail,
      personUnifiedNumber = '',
      requestNumber = ''
    }
  } = formStore.draft || {}
  const { serviceTransactionId } = formStore.extraMap
  if (referenceRequestNumber && nominationEmail) {
    let params = {
      serviceTransactionId,
      unifiedNumber: personUnifiedNumber,
      requestNumbe: referenceRequestNumber,
      emailAddress: nominationEmail,
      serviceRequestNumber: requestNumber
    }
    let res = await axios.request({
      url: '/api/NominationGoldenVisa/draft/checkIfEligableForNominationRequest',
      method: 'GET',
      params
    })
    if (res.errorMessage) {
      formStore.draft.request = {
        ...formStore.draft.request,
        referenceRequestNumber: '',
        nominationEmail: '',
        personUnifiedNumber: '',
        englishName: '',
        arabicName: '',
        currentNationalityId: '',
        dateOfBirth: '',
        genderId: '',
        countryOfBirthId: '',
        professionId: '',
        passportNumber: '',
        issuanceVisaEmirateId: ''
      }
      formStore.form.setValues({
        referenceRequestNumber: '',
        nominationEmail: '',
        personUnifiedNumber: '',
        englishName: '',
        arabicName: '',
        currentNationalityId: '',
        dateOfBirth: '',
        genderId: '',
        countryOfBirthId: '',
        professionId: '',
        passportNumber: '',
        issuanceVisaEmirateId: ''
      })
      formStore.extraMap.isNominationRequestValid = false
    } else {
      formStore.extraMap.isNominationRequestValid = true
      const {
        personUnifiedNumber = '',
        englishName = '',
        arabicName = '',
        currentNationalityId = '',
        dateOfBirth = '',
        genderId = '',
        countryOfBirthId = '',
        professionId = '',
        passportNumber = '',
        localEmirateId = '',
        administrativeRegionId = '',
        englishApplicantName = '',
        arabicApplicantName = '',
        applicantMobile = '',
        applicantEmail = '',
        preferedLanguageId = '',
        transactionReason: { id = '', text = '' }
      } = res.visaRequest || {}
      formStore.draft.request = {
        ...formStore.draft.request,
        personUnifiedNumber,
        englishName,
        arabicName,
        currentNationalityId,
        dateOfBirth,
        genderId,
        countryOfBirthId,
        professionId,
        passportNumber
      }
      formStore.form.setValues({
        personUnifiedNumber,
        englishName,
        arabicName,
        currentNationalityId,
        dateOfBirth,
        genderId,
        countryOfBirthId,
        professionId,
        passportNumber
      })
      if (res.visaRequest.localEmirateId) {
        formStore.draft.request.issuanceVisaEmirateId = localEmirateId
        formStore.form.setValues({
          issuanceVisaEmirateId: localEmirateId
        })
      }
      // fill data of nomination request
      if (nomantionRequestNumber && userEmail) {
        if (id) {
          formStore.draft.request = {
            ...formStore.draft.request,
            transactionReasonId: id
            // transactionReasonCode: text
          }
          formStore.form.setValues({
            transactionReasonId: id
          })
        }
        if (administrativeRegionId) {
          formStore.draft.request.issuanceVisaEmirateId = administrativeRegionId
        }
        formStore.draft.request = {
          ...formStore.draft.request,
          englishApplicantName,
          arabicApplicantName,
          applicantMobile,
          applicantEmail,
          preferedLanguageId
        }
        formStore.form.setValues({
          englishApplicantName,
          arabicApplicantName,
          applicantMobile,
          applicantEmail,
          preferedLanguageId
        })
      }
    }
  }
}
export default function () {
  return {
    initializeCardOnTheBegin,
    readDataFromCard,
    retriveVisaInformation,
    selectIdentificater,
    checkNominationRequestNumber
  }
}
